import mainTextarea from '@/components/atoms/main-textarea/index.vue';
import mainButton from '@/components/atoms/buttons/main/index.vue'

export default {
    name: 'RateComment',
    components: {
        mainTextarea,
        mainButton
    },
    props: {
        value: {
            required: false,
            type: String
        },
        progress: {
            required: false,
            type: Boolean,
            default: false,
        },
        inEdit: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            validationRules: {
                required: true
            }
        }
    },
    mounted() {
        if (this.$route.query.scrollTo === 'rate') {
            this.$el.scrollIntoView({behavior: "smooth", block: "center"});
        }
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        onSubmit() {
            // if (this.rateCommentInput.$v.touch) {
            //   return
            // }
            this.$emit('submit', this.value);
        },
        cancel() {
            this.$emit('cancel', true);
        },
        needEditEvent() {
            this.$emit('needEdit', true);
        }
    }
}
